<template>
  <v-container fluid class="ml-1 ml-sm-0 ql-editor" >
        <v-row v-if="getL(language)" wrap class="mt-n2 mb-0  pt-0">
            <v-col cols="12" class="my-0 mx-1 pt-0  body-1 font-weight-bold">
                <v-btn v-if="bo" x-small class="mt-0 white--text" color="green darken-4"
                        :to="{name:'message.library.bo'}" >
                        edit message
                </v-btn>
                <p  v-if="libraryLanguage.en" class="mr-2 my-0 pa-0" >
                    <span v-if="libraryLanguage.en.message" v-html="libraryLanguage.en.message"></span>
                </p>
            </v-col>
            <v-col cols="12" md="4" sm="6" class="mx-1 black--text">
                <p class="body-1 mt-0 mb-0 py-0 font-weight-bold">{{ $t("library.hours") }}
                    <v-btn v-if="bo" x-small class="mt-0 ml-2 white--text" color="green darken-4"
                            :to="{name:'hours.library.bo'}" >
                            edit
                    </v-btn>
                </p>
                <div v-if="libraryLanguage.en"  v-html="libraryLanguage.en.hours"></div>
            </v-col>
            <v-col cols="12" md="3" sm="5"  class=" black--text mt-0 mt-sm-6">
                <span class="body-2 font-weight-bold pr-1">{{ $t("library.address") }}:</span>
                <v-btn v-if="bo" x-small class="mt-0 ml-2 white--text" color="green darken-4"
                            :to="{name:'address.library.bo'}" >
                            edit
                </v-btn>
                <p v-if="libraryLanguage.en" class="body-2 pt-0 my-0" v-html="libraryLanguage.en.address"></p>
                <div class="py-3 my-0">
                    <span class="body-2 font-weight-bold pr-1">{{ $t("researcher.telephone") }}:</span>
                    <p v-if="libraryLanguage.en" class="body-2 pt-0 my-0" v-html="libraryLanguage.en.phone"></p>
                </div>
                <p v-if="libraryLanguage.en" class="body-2 pb-2 my-0" >
                    <a :href="'mailto:'+libraryLanguage.en.email" class="body-2">
                        <span class="black--text font-weight-bold pr-1">E-mail:</span>{{ libraryLanguage.en.email }}</a>
                </p>
            </v-col>
            <v-col cols="12" md="4">
                <app-contact-map style="height:250px; width: 100%"></app-contact-map>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12" class="my-0 mx-1 pt-0  body-1 font-weight-bold">
                <v-btn v-if="bo" x-small class="mt-0 white--text" color="green darken-4"
                        :to="{name:'message.library.bo'}" >
                        edit message
                </v-btn>
                <p  v-if="libraryLanguage.cz" class="mr-2 my-0 pa-0" >
                    <span v-if="libraryLanguage.cz.message" v-html="libraryLanguage.cz.message"></span>
                </p>
            </v-col>
            <v-col cols="12" md="4" sm="6" class="mx-1 black--text">
                <p class="body-1 mt-0 mb-3 py-0 font-weight-bold">{{ $t("library.hours") }}
                    <v-btn v-if="bo" x-small class="mt-0 ml-2 white--text" color="green darken-4"
                            :to="{name:'hours.library.bo'}" >
                            edit
                    </v-btn>
                </p>
                <div  v-if="libraryLanguage.cz"  v-html="libraryLanguage.cz.hours"></div>
            </v-col>
            <v-col cols="12" md="3" sm="5"  class=" black--text mt-0 mt-sm-6">
                <span class="body-2 font-weight-bold pr-1">{{ $t("library.address") }}:</span>
                <v-btn v-if="bo" x-small class="mt-0 ml-2 white--text" color="green darken-4"
                            :to="{name:'address.library.bo'}" >
                            editlibraryRules
                </v-btn>
                 <p v-if="libraryLanguage.cz" class="body-2 pt-0 my-0" v-html="libraryLanguage.cz.address"></p>
                 <div class="py-3 my-0">
                    <span class="body-2 font-weight-bold pr-1">{{ $t("researcher.telephone") }}:</span>
                    <p v-if="libraryLanguage.cz" class="body-2 pt-0 my-0" v-html="libraryLanguage.cz.phone"></p>
                </div>
                <p class="body-2 pb-2 my-0"  v-if="libraryLanguage.cz">
                    <a :href="'mailto:'+libraryLanguage.cz.email" class="body-2">
                    <span class="black--text font-weight-bold pr-1">E-mail:</span>{{ libraryLanguage.cz.email }}</a>
                </p>
            </v-col>
            <v-col cols="12" md="4">
                <app-contact-map style="height:250px; width: 100%"></app-contact-map>
            </v-col>
        </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import contactMap from '../../about/contact/ContacMapt.vue';
import router from '../../../router';

export default {
    name:"library",
    props:{
        bo: {
            type:Boolean,
            default:false
        },
    },
    data(){
        return {
            libraryLanguage:{'en':null,
              'cz':null},
            style:"height:280px; width: 100%",
        }
    },
    created(){
        this.getLibrary(this.language);
        this.setCurrentLibTabComponent('AppHomeLibrary');
    },
    components:{
        'AppContactMap':contactMap,
    },
    computed: {
        ...mapGetters('header',{
            language:'language',
        }),

    },
    methods:{
         ...mapActions('library',{
            setCurrentLibTabComponent:'setCurrentLibTabComponent',
        }),
        async getLibrary(lang){
            try{
                const res = await axios.get('/index.php/api/library/home/'+lang);
                if(res){
                    this.libraryLanguage[lang] = res.data;
                }
            } catch (error) {
                throw error;
            }
        },
        getL(lang){
            if(lang == 'en'){
                if( this.libraryLanguage.en == null){
                    this.getLibrary(lang)
                }
                return true;
            }
            else{
                if( this.libraryLanguage.cz == null){
                    this.getLibrary(lang)
                }
                return false;
            }
        }
    },

}
</script>
